import { useTranslation } from "react-i18next";

const VehicleCard = ({
    index,
    value,
}) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const getVehicleKey = (name) => name.replace(/ /g, ".");

    return (
        <div
            key={index}
            className="tw:rounded-[5px] tw:lg:border tw:lg:border-[#e8e8e8] tw:bg-white tw:p-5"
        >
            <div className="tw:flex tw:justify-center tw:items-center tw:h-[152px] tw:w-full">
                <img
                    src={value.vehicleTypeID?.images?.png}
                    className="tw:w-full tw:rounded-t-[0.3rem] tw:!px-10 tw:!h-auto"
                    alt=""
                />
            </div>
            <div className="tw:mt-6 tw:flex tw:flex-col">
                <div className="tw:font-['noto-serif-jp'] tw:text-[7px] tw:font-bold tw:uppercase tw:leading-normal tw:tracking-[3px] tw:text-[#282828]">
                    {t(`${getVehicleKey(value.vehicleTypeName)}.Tag`)}
                </div>
                <div className="tw:font-libre-caslon-display tw:text-[26px] tw:leading-[35px] tw:text-[#212529]">
                    {t(`${getVehicleKey(value.vehicleTypeName)}`)}
                </div>
            </div>
            {
                getVehicleKey(value.vehicleTypeName) === "Toyota.Alphard" && (
                    <div className="tw:mt-6 tw:flex tw:flex-col">
                        <p className="tw:!m-0 tw:!text-[12px] tw:!font-[400] tw:!text-[#8D8D8D]">
                            {t("bookingDetail.vehicleCard.AlphardNote")}
                        </p>
                    </div>
                )
            }
        </div>
    );
};

export default VehicleCard;